/**
 * Safely reads text from the clipboard, returning an empty string
 * when the Clipboard API is unavailable or permission is denied.
 */
export async function readClipboardText(): Promise<string> {
    try {
        return await navigator.clipboard.readText();
    } catch {
        return '';
    }
}
